export const HOME_TILE_ARG_CATEGORY = "category";
export const HOME_TILE_ARG_PAYMENT_METHOD = "paymentMethod";
export const HOME_TILE_ARG_SERVICE = "service";
export const HOME_TILE_ARG_SUPPLIER = "supplier";
const HOME_TILE_BLANK_KEY = "blank";

export const homeTileCatalog = [
  { key: "time-now", labelKey: "homeTileTime" },
  { key: "date-today", labelKey: "homeTileDate" },
  { key: "spent-total-this-month", labelKey: "homeTileSpentTotalThisMonth" },
  { key: "spent-total-last-month", labelKey: "homeTileSpentTotalLastMonth" },
  { key: "spent-total-this-year", labelKey: "homeTileSpentTotalThisYear" },
  { key: "spent-ongoing-this-month", labelKey: "homeTileSpentOngoingThisMonth" },
  { key: "spent-ongoing-last-month", labelKey: "homeTileSpentOngoingLastMonth" },
  { key: "spent-ongoing-this-year", labelKey: "homeTileSpentOngoingThisYear" },
  { key: "spent-irregular-this-month", labelKey: "homeTileSpentIrregularThisMonth" },
  { key: "spent-irregular-last-month", labelKey: "homeTileSpentIrregularLastMonth" },
  { key: "spent-irregular-this-year", labelKey: "homeTileSpentIrregularThisYear" },
  {
    key: "category-spent-this-month",
    labelKey: "homeTileCategorySpentThisMonth",
    arg: { key: "category", labelKey: "category", type: HOME_TILE_ARG_CATEGORY }
  },
  {
    key: "category-spent-this-year",
    labelKey: "homeTileCategorySpentThisYear",
    arg: { key: "category", labelKey: "category", type: HOME_TILE_ARG_CATEGORY }
  },
  {
    key: "supplier-spent-this-month",
    labelKey: "homeTileSupplierSpentThisMonth",
    arg: { key: "supplier", labelKey: "supplier", type: HOME_TILE_ARG_SUPPLIER }
  },
  {
    key: "supplier-spent-this-year",
    labelKey: "homeTileSupplierSpentThisYear",
    arg: { key: "supplier", labelKey: "supplier", type: HOME_TILE_ARG_SUPPLIER }
  },
  {
    key: "service-spent-this-month",
    labelKey: "homeTileServiceSpentThisMonth",
    arg: { key: "service", labelKey: "service", type: HOME_TILE_ARG_SERVICE }
  },
  {
    key: "service-spent-this-year",
    labelKey: "homeTileServiceSpentThisYear",
    arg: { key: "service", labelKey: "service", type: HOME_TILE_ARG_SERVICE }
  },
  {
    key: "payment-method-spent-this-month",
    labelKey: "homeTilePaymentMethodSpentThisMonth",
    arg: { key: "paymentMethod", labelKey: "paymentMethod", type: HOME_TILE_ARG_PAYMENT_METHOD }
  },
  {
    key: "payment-method-spent-this-year",
    labelKey: "homeTilePaymentMethodSpentThisYear",
    arg: { key: "paymentMethod", labelKey: "paymentMethod", type: HOME_TILE_ARG_PAYMENT_METHOD }
  },
  { key: "budget-remaining-this-month", labelKey: "homeTileBudgetRemainingThisMonth" },
  { key: "budget-remaining-this-year", labelKey: "homeTileBudgetRemainingThisYear" },
  { key: "budget-total-this-year", labelKey: "homeTileBudgetTotalThisYear" },
  { key: "projection-projected-spend-this-year", labelKey: "homeTileProjectionProjectedSpendThisYear" },
  { key: "projection-implied-spend-this-month", labelKey: "homeTileProjectionImpliedSpendThisMonth" },
  { key: "meter-ongoing", labelKey: "homeTileMeterOngoing", meter: "ongoing" },
  { key: "meter-total", labelKey: "homeTileMeterTotal", meter: "total" },
  { key: "chart-expenses", labelKey: "homeTileChartExpenses", chart: "expenses" },
  {
    key: "chart-category-expenses",
    labelKey: "homeTileChartCategoryExpenses",
    chart: "category-expenses",
    arg: { key: "category", labelKey: "category", type: HOME_TILE_ARG_CATEGORY }
  },
  {
    key: "chart-supplier-expenses",
    labelKey: "homeTileChartSupplierExpenses",
    chart: "supplier-expenses",
    arg: { key: "supplier", labelKey: "supplier", type: HOME_TILE_ARG_SUPPLIER }
  },
  {
    key: "chart-service-expenses",
    labelKey: "homeTileChartServiceExpenses",
    chart: "service-expenses",
    arg: { key: "service", labelKey: "service", type: HOME_TILE_ARG_SERVICE }
  },
  {
    key: "chart-payment-method-expenses",
    labelKey: "homeTileChartPaymentMethodExpenses",
    chart: "payment-method-expenses",
    arg: { key: "paymentMethod", labelKey: "paymentMethod", type: HOME_TILE_ARG_PAYMENT_METHOD }
  },
  { key: HOME_TILE_BLANK_KEY, labelKey: "homeTileBlank", blank: true }
];

export function findHomeTileCatalogEntry(metricKey) {
  return homeTileCatalog.find((entry) => entry.key === metricKey) ?? homeTileCatalog[0];
}
